<template>
  <div :class="$style.buttonfixed">
    <div :class="$style.buttonBox">
      <p :class="$style.popText">
        満足度<span :class="$style.popSubText">98%</span>のキャリアコンサル
      </p>
      <nuxt-link :class="$style.button" :to="fullUrl('/')">
        <span :class="$style.buttonText">無料カウンセリングはこちら</span>
      </nuxt-link>
    </div>
  </div>
</template>

<style module lang="scss">
.buttonfixed {
  z-index: 999;
  position: fixed;
  height: auto;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: mp(20) 0;
  background: rgba(255, 255, 255, 0.8);

  @include sp {
    padding: mp(20);
  }
}

.popText {
  width: 24.2rem;
  margin: 0 auto;
  padding: mp(4) mp(12);
  text-align: center;
  border-radius: mp(32);
  border: 0.1rem solid colors(top-darker-orange);
  background: colors(base-light);
  color: colors(base-hover);
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.028rem;
  position: absolute;
  top: -1.4rem;
  right: 0;
  left: 0;
  white-space: nowrap;
}

.popSubText {
  color: colors(top-darker-orange);
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 100%;
  margin: 0 0.2rem;
  vertical-align: -0.1rem;
}

.buttonBox {
  position: relative;
  text-align: center;

  @include sp {
    width: 100%;
  }
}

.button {
  width: 500px;
  height: 6.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @include sp {
    width: 100%;
  }
}

.buttonText {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: mp(4);
  width: 100%;
  height: 100%;
  padding: mp(8) mp(12);
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 100%;
  color: colors(base-light);
  background-color: colors(top-orange);

  @include hover {
    background-color: colors(top-orange-hover);
  }
}
</style>
